import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'website-empty',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class EmptyComponent {}
